import getSymbolFromCurrency from 'currency-symbol-map'

export const currencySymbol = () => {
    return getSymbolFromCurrency('USD');
}